<template>
  <div class="title">
    <div class="title-font" text="衡水市中小学基本情况统计">
      衡水市中小学基本情况统计
    </div>
    <div class="update">
      <span>最新监测时间：{{ updateTime | formatHourToSlash }}</span>
      <span class="update-button" @click="updateData">更新数据</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['updateTime'],

  components: {},

  data() {
    return {
    }
  },

  watch: {},

  computed: {},

  mounted() {},

  methods: {
    updateData () {
      this.$emit('update-data')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 4.2vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../../assets/big-screen/title.png") center no-repeat;
  background-size: 100% 100%;
}
.title-font {
  color: #fff;
  font-size: 1.8vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 50px;
}
.title-font:before {
  content: attr(text);
  position: absolute;
  z-index: 10;
  color: #43f9ff;
  mask: linear-gradient(to top, #43f9ff, transparent);
}
.update {
  position: absolute;
  top: 0.7vw;
  right: 30px;
  color: #43f9ff;
  font-size: 0.7vw;
}
.update-button {
  display: inline-block;
  margin-left: 20px;
  padding: 4px 12px;
  border-radius: 32px;
  border: 1px solid #43f9ff;
  cursor: pointer;
}</style>



// WEBPACK FOOTER //
// src/components/big-screen/ScreenHeader.vue